<div style="position: relative;">
  <i class="fal fa-times-circle cancelX" mat-button cdkFocusInitial (click)="onCancelClick()"></i>
</div>

<div class="title">
  <span>{{ 'dashboard:Add dashboard' | i18next }}</span>
</div>
<!-- <h2>{{ 'dashboard:Add dashboard' | i18next }}</h2>
<div class="line">
  <div></div>
</div> -->

<div class="dialog-content">
  <div class="info">
    <span>
      {{ 'dashboard:Dashboard name' | i18next }}
    </span>
    <div>
      <input matInput [(ngModel)]="data.name" (keyup.enter)="dialogRef.close(data)" maxlength="40" type="text"
        placeholder="{{'dashboard:Type dashboard name' | i18next }}..." />
    </div>
    <div style="padding-top: 7px;">
      {{ 'dashboard:Visibility Permissions' | i18next }}
      <mat-radio-button (click)="setPrivate()" id="access_private" [checked]="!data.isPublic">{{
        'translation:Private' |
        i18next }}</mat-radio-button>
      <mat-radio-button (click)="setPublic()" id="access_public" [checked]="data.isPublic">{{
        'translation:Company' |
        i18next }}</mat-radio-button>
      <!-- <input type="radio" id="access_private" name="access" [(ngModel)]="data.isPublic" [value]="false" /><label
        for="access_private"> {{ 'dashboard:Private' | i18next }}</label>
      <input type="radio" id="access_public" name="access" [(ngModel)]="data.isPublic" [value]="true" /><label
        for="access_public"> {{ 'dashboard:Company' | i18next }}</label> -->
    </div>
  </div>
</div>

<mat-dialog-actions style="justify-content: space-between;">
  <button matButton (click)="onCancelClick()" class="secondary-button">{{ 'Cancel' | i18next }}</button>
  <button matButton [mat-dialog-close]="data" [disabled]="data.name.trim().length == 0" class="primary-button">{{
    'Add' | i18next }}</button>
</mat-dialog-actions>